import { render } from "./MaintenanceNote.vue?vue&type=template&id=665404f0&scoped=true"
import script from "./MaintenanceNote.vue?vue&type=script&lang=js"
export * from "./MaintenanceNote.vue?vue&type=script&lang=js"

import "./MaintenanceNote.vue?vue&type=style&index=0&id=665404f0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665404f0"]])

export default __exports__